import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import '../assets/styles/Certifications.scss';

interface Certification {
  name: string;
  issuer: string;
  description: string;
  iconType?: 'aws' | 'redhat' | 'default';
  credlyUrl?: string;
}

const certifications: Certification[] = [
  {
    name: "AWS Certified Solutions Architect – Professional",
    issuer: "Amazon Web Services",
    description: "Advanced cloud architecture design, complex solutions, and enterprise-scale deployments",
    iconType: "aws",
    credlyUrl: "https://www.credly.com/badges/6d99c289-02ff-41c5-844a-390519478ea7",
  },
  {
    name: "AWS Certified DevOps Engineer – Professional",
    issuer: "Amazon Web Services",
    description: "CI/CD pipelines, infrastructure automation, monitoring, and operational excellence",
    iconType: "aws",
    credlyUrl: "https://www.credly.com/badges/e78e7b25-80d5-4d31-ab34-c0c99d14294d",
  },
  {
    name: "AWS Certified Solutions Architect – Associate",
    issuer: "Amazon Web Services",
    description: "Cloud architecture fundamentals, AWS services integration, and best practices",
    iconType: "aws",
    credlyUrl: "https://www.credly.com/badges/c81fb7b8-b6e2-4d96-8ff9-494df15c8abb",
  },
  {
    name: "AWS Certified Advanced Networking – Specialty",
    issuer: "Amazon Web Services",
    description: "Complex networking tasks, hybrid connectivity, and network architecture design",
    iconType: "aws",
    credlyUrl: "https://www.credly.com/badges/7c828939-8e83-473c-9a27-4ddeb2bbd0b1",
  },
  {
    name: "AWS Certified Security – Specialty",
    issuer: "Amazon Web Services",
    description: "Security controls, compliance, incident response, and data protection in AWS",
    iconType: "aws",
    credlyUrl: "https://www.credly.com/badges/e946d710-529f-4c75-b9a5-d81a34d6e6e8",
  },
  {
    name: "Red Hat Certified System Administrator",
    issuer: "Red Hat",
    description: "Linux system administration, configuration management, and enterprise operations",
    iconType: "redhat",
    credlyUrl: "https://www.credly.com/badges/1237e8a3-a644-4007-91e5-284b504944e2",
  },
];

function Certifications() {
  const renderLogo = (iconType?: string) => {
    switch (iconType) {
      case 'aws':
        return <img src={require('../assets/images/aws.png')} alt="AWS" className="cert-logo" />;
      case 'redhat':
        return <img src={require('../assets/images/rh.png')} alt="Red Hat" className="cert-logo" />;
      default:
        return null;
    }
  };

  return (
    <div className="container" id="certifications">
      <div className="certifications-container">
        <div className="certifications-header">
          <span className="certifications-tag">{'// Credentials'}</span>
          <h1>5 AWS certs. One Red Hat.</h1>
        </div>
        <div className="certifications-grid">
          {certifications.map((cert, index) => (
            <div key={index} className="certification-card">
              <div className="certification-top">
                {renderLogo(cert.iconType)}
                <div className="certification-info">
                  <h3>{cert.name}</h3>
                  <span className="cert-issuer">{cert.issuer}</span>
                </div>
              </div>
              <p className="cert-description">{cert.description}</p>
              {cert.credlyUrl && (
                <a
                  href={cert.credlyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="cert-verify-link"
                >
                  Verify on Credly
                  <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Certifications;
